import React from "react";
import ReactStars from "react-rating-stars-component";
import { Add, Microphone2 } from "iconsax-react";
import { useTranslation } from "react-i18next";
import FileSelector from "./FileSelector";
import { ReactComponent as StarIcon } from "../assets/icons/starIcon.svg";
import { ReactComponent as EmptyStarIcon } from "../assets/icons/emptyStarIcon.svg";

export default function OverallScoreSection({
    result,
    noteHandle,
    scoreHandle,
    setRecordBoxID,
    fileSelectorHandle,
    overalScoreHandle,
}) {
    const { t } = useTranslation();

    return (
        <div className="clean-star">
            <div className="container">
                <p>{t("overalsat.label")}</p>
                <div className="rating-stars" dir="ltr">
                    <ReactStars
                        count={5}
                        onChange={scoreHandle}
                        size={2}
                        activeColor="#2e71fc"
                        filledIcon={<StarIcon />}
                        emptyIcon={<EmptyStarIcon />}
                    />
                    <div>
                        <button
                            className={result.data.voice ? "selected" : ""}
                            onClick={() => setRecordBoxID(0)}
                        >
                            <Microphone2 />
                        </button>
                        <button
                            className={result.data.file ? "selected" : ""}
                        >
                            <FileSelector
                                fileId={0}
                                files={(e) => fileSelectorHandle(0, e)}
                                image
                            />
                        </button>
                    </div>
                </div>
            </div>
            <div className="clean-star-input">
                <div>
                    <textarea
                        placeholder={t("note.label")}
                        value={result.data.description || ""}
                        rows={3}
                        onChange={(e) => noteHandle(e.target.value, 0)}
                    />
                </div>
            </div>
            <div className="overal-rating-caption">
                {result.data.file ? (
                    <div className="tag-list">
                        <div onClick={() => overalScoreHandle("file")}>
                            <Add size={16} className="close-btn" />
                        </div>
                        <div>{t("image.label")}</div>
                    </div>
                ) : null}
                {result.data.voice ? (
                    <div className="tag-list">
                        <div onClick={() => overalScoreHandle("voice")}>
                            <Add size={16} className="close-btn" />
                        </div>
                        <div>{t("voice.label")}</div>
                    </div>
                ) : null}
            </div>
        </div>
    );
}
